import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import storage from 'redux-persist/lib/storage'; // Usa localStorage para guardar el estado
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { trackAddToCart } from '../utils/metaPixel';


const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  cart: cartReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const metaPixelMiddleware = () => (next) => (action) => {
  const result = next(action);

  if (action.type === 'cart/addToCart') {
    trackAddToCart(action.payload);
  }

  return result;
};

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REGISTER'],
        ignoredPaths: ['register'], // Ignora la propiedad "register"
      },
    }).concat(metaPixelMiddleware),
});

export const persistor = persistStore(store);
export default store;
